export function initEmitter() {
    const callbacks = [];
    function off(func) {
        const index = callbacks.indexOf(func);
        if (index >= 0) {
            callbacks.splice(index, 1);
        }
    }
    function on(func) {
        callbacks.push(func);
        return () => off(func);
    }
    return {
        on,
        off,
        emit(v) {
            for (const callback of callbacks) {
                callback(v);
            }
        },
    };
}
